const escapeDict = { b: '\b', f: '\f', n: '\n', r: '\r', t: '\t', v: '\v' };
/** unescape slashes of string */
export function unescapeString(str) {
    return typeof str === 'string' ? str.replace(/\\(u\d{4}|[^u])/g, (_, x) => {
        if (x[0] === 'u')
            return String.fromCharCode(parseInt(x.slice(1), 16));
        return escapeDict[x] || x;
    }) : str;
}
